import { Component } from '@angular/core';

import { StepsStoreService } from '../core/services';

import { DocumentTypes, IdType, PassportSide } from '../models/documentType';
import { IdentificationSteps } from '../models/identificationSteps';

@Component({
  selector: 'app-success-capture',
  templateUrl: './success-capture.component.html',
  styleUrls: ['./success-capture.component.scss']
})
export class SuccessCaptureComponent {
  documentTypes = DocumentTypes;
  idTypes = IdType;

  passportSide = PassportSide;
  steps = IdentificationSteps;

  constructor(public stepsStore: StepsStoreService) { }

  next() {
    this.stepsStore.step.qrCode = null;
    let doubleSidedDutchPassport = false;

    if (this.stepsStore.step.passportSide === PassportSide.FRONT) {
      // double sided dutch passport
      if (this.stepsStore.step.mrz.countryCode === 'NLD' && this.stepsStore.step.mrz.hasOptionalData === false) {
        doubleSidedDutchPassport = true;
      }
    }

    if (this.stepsStore.step.idSide === IdType.FRONT) {
      this.stepsStore.step = {
        ...this.stepsStore.step,
        idSide: IdType.BACK
      };
    }
    else if (doubleSidedDutchPassport) {
      this.stepsStore.step = {
        ...this.stepsStore.step,
        passportSide: PassportSide.BACK,
        documentType: DocumentTypes.QR_BARCODE
      };
    }
    else {
      this.stepsStore.next = this.stepsStore.step.selfieRequired ? IdentificationSteps.SELFIE : IdentificationSteps.OVERVIEW;
    }

    this.stepsStore.step.success = false;
  }

}
